import { DroitSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const DroitModel: SelectorModel = {
  name: 'droits',
  getSelector: DroitSelectors.selectAllDroitsDictionary,
  isReady: DroitSelectors.selectIsReadyDroit
};
